import { createSelector } from 'reselect'

const getMyAccountData = state => state.myAccount
const getCurrentLibrary = state => state.libraries.current.libraryUID

const defaultData = {
	schools: [],
}

const privateLibrarySwitchModalSelector = createSelector(
	[ getMyAccountData, getCurrentLibrary ],
	(myAccountData, currentLibraryId) => {
		let switchLibraryData = {}
		if (myAccountData.data) {
			switchLibraryData.schools = myAccountData.schools.filter(school => school.privateLibraryId != currentLibraryId)
		} else {
			switchLibraryData = defaultData
		}
		return switchLibraryData
	}
)

export default privateLibrarySwitchModalSelector
